import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";
import { useModal } from "../../../contexts/ModalContext";
import { useToast } from "../../../contexts/ToastContext";
import { GoTrash } from "react-icons/go";
import { FiDownload } from "react-icons/fi";
import {
    AiOutlineFilePdf,
    AiOutlineFileImage,
    AiOutlineFileWord,
    AiOutlineFileExcel,
    AiOutlineFileUnknown,
    AiOutlineLoading,
} from "react-icons/ai";
import ConfirmDeleteAnexoFaturamentoDireto from "./ConfirmDeleteAnexoFaturamentoDireto";

const Header = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 15px;
    align-items: center;
    min-width: 0;
`;
const Titulo = styled.h2`
    margin: 0;
    font-size: 16px;
    color: #333;
    flex: 1;
    min-width: 0;
`;
const Resumo = styled.div`
    font-size: 13px;
    color: #555;
    margin-bottom: 12px;
    line-height: 1.45;
    p {
        margin: 4px 0;
    }
`;
const BotaoAdicionar = styled.button`
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    flex-shrink: 0;
    &:hover {
        background-color: #1e40af;
    }
    transition: 0.2s all ease;
    padding: 10px 12px;
    box-sizing: border-box;
    margin-left: 12px;
    &:disabled {
        background-color: #93c5fd;
        cursor: not-allowed;
    }
`;
const Container = styled.div`
    width: 100%;
    max-height: min(52vh, 420px);
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
`;
const Lista = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;
const Linha = styled.li`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 13px;
    color: #333;
    min-width: 0;
    &:nth-child(even) {
        background-color: #fafafa;
    }
    &:hover {
        background-color: #e0f7fa;
    }
`;
const NomeArquivo = styled.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
const IconWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`;
const IconBtn = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 4px;
    border: none;
    background: transparent;
    border-radius: 6px;
    transition: 0.2s ease;
    &:hover:not(:disabled) {
        background: rgba(0, 0, 0, 0.06);
    }
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
const Lixeira = styled(GoTrash)`
    height: 20px;
    width: 20px;
    color: #e11d48;
`;
const DownloadIco = styled(FiDownload)`
    height: 20px;
    width: 20px;
    color: #334155;
`;
const DownloadIcoLoading = styled(AiOutlineLoading)`
    height: 20px;
    width: 20px;
    color: #2563eb;
    animation: fatDirSpin 0.85s linear infinite;
    @keyframes fatDirSpin {
        to {
            transform: rotate(360deg);
        }
    }
`;
const Vazio = styled.p`
    margin: 0;
    padding: 24px;
    text-align: center;
    color: #64748b;
    font-size: 14px;
`;

function nomeAnexo(a) {
    return a?.original_nome || a?.nome || "Arquivo";
}

function getFileIcon(filename) {
    const name = String(filename || "").toLowerCase();
    if (name.endsWith(".png") || name.endsWith(".jpg") || name.endsWith(".jpeg")) {
        return <AiOutlineFileImage size={22} color="#4a90e2" />;
    }
    if (name.endsWith(".pdf")) {
        return <AiOutlineFilePdf size={22} color="#e63946" />;
    }
    if (name.endsWith(".doc") || name.endsWith(".docx")) {
        return <AiOutlineFileWord size={22} color="#2a6db0" />;
    }
    if (name.endsWith(".xls") || name.endsWith(".xlsx")) {
        return <AiOutlineFileExcel size={22} color="#207245" />;
    }
    return <AiOutlineFileUnknown size={22} color="#555" />;
}

const ModalAnexosFaturamentoDireto = ({ faturamento, numPedido, onFechar }) => {

    const { id: idPc } = useParams();
    const api = useApi();
    const { isModalOpen, openModal, closeModal } = useModal();
    const { notifySuccess, notifyError } = useToast();
    const fileRef = useRef(null);

    const [anexos, setAnexos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [selectedAnexoId, setSelectedAnexoId] = useState(null);
    const [downloadingIds, setDownloadingIds] = useState([]);

    const fetchAnexos = async () => {

        if (!faturamento?.id || !idPc) {
            return;
        }

        setLoading(true);

        try {

            const { data } = await api.get(
                `/Painel/API/ControleMedicao/ListAnexosFaturamentoDireto/index.php?id_faturamento=${faturamento.id}&id_pc=${idPc}`
            );
            const list = Array.isArray(data?.anexos) ? data.anexos : [];
            setAnexos(list);

        } catch (e) {

            console.error(e);
            setAnexos([]);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        fetchAnexos();

    }, [faturamento?.id, idPc]);

    const fechar = () => {

        closeModal();
        if (typeof onFechar === "function") {
            onFechar();
        }

    };

    const handleDownload = async (anexo) => {

        if (anexo?.id == null) {
            return;
        }

        setDownloadingIds((prev) => [...prev, anexo.id]);

        try {

            const { data } = await api.get(
                `/Painel/API/ControleMedicao/DownloadAnexoFaturamentoDireto/index.php?id=${anexo.id}&id_pc=${idPc}`,
                { responseType: "blob" }
            );

            saveAs(data, nomeAnexo(anexo));

        } catch (e) {

            console.error(e);
            notifyError("Não foi possível baixar o arquivo.");

        } finally {

            setDownloadingIds((prev) => prev.filter((x) => x !== anexo.id));

        }

    };

    const handlePickFiles = () => {
        fileRef.current?.click();
    };

    const handleFileChange = async (e) => {

        const files = Array.from(e.target.files || []);
        e.target.value = "";
        if (!files.length || !faturamento?.id) {
            return;
        }

        setUploading(true);

        try {

            const formData = new FormData();
            formData.append("id_faturamento", String(faturamento.id));
            formData.append("id_pc", String(idPc));
            files.forEach((file) => {
                formData.append("files[]", file);
            });

            await api.post(
                "/Painel/API/ControleMedicao/AddAnexoFaturamentoDireto/",
                formData
            );

            notifySuccess("Anexos enviados com sucesso.");
            await fetchAnexos();

        } catch (err) {

            const msg = err?.response?.data?.message || "Erro ao enviar anexos.";
            notifyError(typeof msg === "string" ? msg : "Erro ao enviar anexos.");
            console.error(err);

        } finally {

            setUploading(false);

        }

    };

    const handleDeleteClick = (anexoId) => {
        setSelectedAnexoId(anexoId);
        openModal("modalDeleteAnexoFatDireto");
    };

    const handleCancelDelete = () => {
        setSelectedAnexoId(null);
        closeModal();
    };

    const titulo = `ANEXOS — PC ${numPedido || "—"}`;

    return (
        <>
            <Overlay state={true}>
                <Modal header close={fechar} size="lg">
                    <Header>
                        <Titulo>{titulo}</Titulo>
                        <BotaoAdicionar
                            type="button"
                            onClick={handlePickFiles}
                            disabled={uploading || !faturamento?.id}
                        >
                            {uploading ? "ENVIANDO..." : "ADICIONAR ARQUIVOS"}
                        </BotaoAdicionar>
                    </Header>
                    <Resumo>
                        <p>
                            <b>DISCIPLINA:</b> {faturamento?.disciplina || "—"}
                        </p>
                        <p>
                            <b>Nº PEDIDO / FORNEC.:</b> {faturamento?.num_pedido_fornec || "—"}
                        </p>
                    </Resumo>
                    <input
                        ref={fileRef}
                        type="file"
                        multiple
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                    />
                    <Container>
                        {loading ? (
                            <Vazio>CARREGANDO...</Vazio>
                        ) : anexos.length === 0 ? (
                            <Vazio>Nenhum anexo cadastrado.</Vazio>
                        ) : (
                            <Lista>
                                {anexos.map((a) => (
                                    <Linha key={a.id}>
                                        {getFileIcon(nomeAnexo(a))}
                                        <NomeArquivo title={nomeAnexo(a)}>{nomeAnexo(a)}</NomeArquivo>
                                        <IconWrap>
                                            <IconBtn
                                                type="button"
                                                title="Baixar"
                                                onClick={() => handleDownload(a)}
                                                disabled={downloadingIds.includes(a.id)}
                                            >
                                                {downloadingIds.includes(a.id) ? (
                                                    <DownloadIcoLoading aria-hidden />
                                                ) : (
                                                    <DownloadIco aria-hidden />
                                                )}
                                            </IconBtn>
                                            <IconBtn
                                                type="button"
                                                title="Excluir"
                                                onClick={() => handleDeleteClick(a.id)}
                                                disabled={uploading}
                                            >
                                                <Lixeira aria-hidden />
                                            </IconBtn>
                                        </IconWrap>
                                    </Linha>
                                ))}
                            </Lista>
                        )}
                    </Container>
                </Modal>
            </Overlay>
            {isModalOpen("modalDeleteAnexoFatDireto") && selectedAnexoId != null && (
                <ConfirmDeleteAnexoFaturamentoDireto
                    id={selectedAnexoId}
                    idPc={idPc}
                    fecharModal={handleCancelDelete}
                    onDelete={fetchAnexos}
                />
            )}
        </>
    );

};

export default ModalAnexosFaturamentoDireto;
